import { Row } from "@/components";
import styles from "../../styles.scss";
import { SORT_COLUMNS } from "@/pages/requests/components/users/components/constants";
import { useCallback } from "react";
import { SortButton } from "@/pages/requests/components/users/components/sort-button";
import { TableHeaderProps } from "@/pages/requests/components/users/types";
import clsx from "clsx";

export const TableHeader = ({
  onSortBy,
  sortDirections,
}: {
  onSortBy: TableHeaderProps["onSortBy"];
  sortDirections: TableHeaderProps["sortDirections"];
}) => {
  const renderSortButton = useCallback(
    (key: SORT_COLUMNS) => {
      return <SortButton _key={key} sortDirections={sortDirections} />;
    },
    [sortDirections],
  );

  return (
    <Row className={clsx(styles.tableHeader, styles.tableHeader7)}>
      <div className={styles.colHeader}>
        <div className={styles.colHeaderRow}>Worker ID</div>
      </div>
      <div className={styles.colHeader}>
        <div
          className={styles.colHeaderRow}
          onClick={() => onSortBy(SORT_COLUMNS.NAME_AR)}
        >
          <span>Name (Arabic)</span>
          {renderSortButton(SORT_COLUMNS.NAME_AR)}
        </div>
      </div>
      <div className={styles.colHeader}>
        <div
          className={styles.colHeaderRow}
          onClick={() => onSortBy(SORT_COLUMNS.NATIONALITY)}
        >
          <span>Nationality</span>
          {renderSortButton(SORT_COLUMNS.NATIONALITY)}
        </div>
      </div>
      <div className={styles.colHeader}>
        <div className={styles.colHeaderRow}>Passport #</div>
      </div>
      <div className={styles.colHeader}>
        <div
          className={styles.colHeaderRow}
          onClick={() => onSortBy(SORT_COLUMNS.JOB_TITLE_AR)}
        >
          <span>Job Title</span>
          {renderSortButton(SORT_COLUMNS.JOB_TITLE_AR)}
        </div>
      </div>
      <div className={styles.colHeader}>
        <div
          className={styles.colHeaderRow}
          onClick={() => onSortBy(SORT_COLUMNS.RESIDENCY_AR)}
        >
          <span>Residency</span>
          {renderSortButton(SORT_COLUMNS.RESIDENCY_AR)}
        </div>
      </div>
      <div className={styles.colHeader}>
        <div
          className={styles.colHeaderRow}
          onClick={() => onSortBy(SORT_COLUMNS.COMPANY)}
        >
          <span>Company</span>
          {renderSortButton(SORT_COLUMNS.COMPANY)}
        </div>
      </div>
    </Row>
  );
};
